var render, staticRenderFns
import script from "./wSlideDown.vue?vue&type=script&lang=js&"
export * from "./wSlideDown.vue?vue&type=script&lang=js&"
import style0 from "./wSlideDown.vue?vue&type=style&index=0&id=4a0d5971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0d5971",
  null
  
)

export default component.exports